import { Frame, Header } from "../components";

const Contato = () => {
  return (
    <>
      <Header />

      <Frame
        body={
          <div className="justify">
            <p>Whatsapp Fretamento: (53) 98122-2534</p>
            <p>Telefone: (53) 3278-7000 ramal 233</p>
            <p>De segunda à sexta, das 08:00 às 12:00 e das 13:30 às 17:30</p>
          </div>
        }
        title="Fale Conosco"
      />
    </>
  );
};

export default Contato;
